import { ReactNode } from "react";
import { Button, Grid, Layout, Typography } from "@payping/web-components";
import { FiArrowRight } from "@payping/icons";
import { useNavigate } from "react-router-dom";
import { useAppTranslation } from "@/utils";

type NavigationLayoutProps = {
  children: ReactNode;
  menu: ReactNode;

  // Just Mobile
  mobileTitle?: string;
  mobileBackNavigation?: string;
};

const NavigationLayout = (props: NavigationLayoutProps) => {
  const navigate = useNavigate();
  const { lg } = Grid.useBreakpoint();

  const { t } = useAppTranslation();

  const desktopLayout = (
    <Layout className={"!tw-p-6"}>
      <Layout.Sider className={"!tw-m-0 !tw-bg-color-bg-base"}>{props.menu}</Layout.Sider>
      <Layout.Content>{props.children}</Layout.Content>
    </Layout>
  );

  const mobileLayout = (
    <Layout>
      <Layout.Header
        className={"!tw-mb-2 tw-flex !tw-items-center !tw-justify-start !tw-bg-color-bg-base tw-px-4"}
        style={{
          boxShadow: "0px 0px 8px 0px #0000001A",
        }}
      >
        <Button
          type={"text"}
          icon={<FiArrowRight strokeWidth={1.5} width={16} />}
          // "" -> meant to happen when it is desktop and this whole mobileLayout not loaded
          onClick={() => navigate(props.mobileBackNavigation || "")}
        />
        <Typography.Text strong className={"!tw-m-0"}>
          {/* || -> meant to happen when it is desktop and this whole mobileLayout not loaded */}
          {t(props.mobileTitle || "")}
        </Typography.Text>
      </Layout.Header>

      <Layout.Content>{props.children}</Layout.Content>
    </Layout>
  );

  return lg ? desktopLayout : mobileLayout;
};

export default NavigationLayout;
